<template>
  <div class="p-emails-tab py-3">
    <div class="p-toolbar">
      <div class="p-toolbar-item p-search">
        <p-search-input
          v-model="search"
          :items="searchSuggestions"
          @submit="searchEmails"
        >
        </p-search-input>
      </div>
      <div class="p-toolbar-item d-inline-flex align-center ml-6">
        <v-switch
          v-model="onlyThisProject"
          :label="$t('email.onlyThisProject')"
          inset
          dense
          class="p-input-switch"
          @click.stop
          @change="reloadProjectThread"
        ></v-switch>
        <v-badge
          :value="unreadEmails"
          icon="mdi-bell"
          overlap
          bordered
          offset-x="7"
          offset-y="7"
          class="ml-8 mt-n2"
        >
          <template v-slot:badge>
            {{ unreadEmails }}
          </template>
          <v-tooltip bottom v-if="unreadEmails">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="grey"
                dark
                v-bind="attrs"
                v-on="on"
              >
                mdi-bell
              </v-icon>
            </template>
            <span>{{ $t('email.notificationUnreadEmailsHint') }}</span>
          </v-tooltip>
        </v-badge>
      </div>
      <div v-if="hasAccess()" class="p-toolbar-item p-right">
        <v-btn
          @click.stop="openSendDialog()"
          large
          rounded
          class="p-btn-rounded mr-4"
        >
          {{ $t('email.newMessage') }}
        </v-btn>
      </div>
    </div>
    <div class="v-main-wrap mt-1">
      <div>
        <v-col sm="3" class="px-0 py-0">
          <v-pagination
            v-if="threadLoaded"
            v-model="page"
            :length="pageCount"
            :total-visible="10"
            class="p-email-pagination mb-2"
            @input="nextPage"
          >
          </v-pagination>
        </v-col>
      </div>
      <v-divider></v-divider>
      <v-row>
        <v-col
          v-if="threadLoaded  && threads.length > 0"
          cols="12"
          sm="6"
          md="5"
          xl="4"
          class="pr-0"
        >
          <v-list class="p-email__list">
            <v-list
              v-for="(group, index) in threadItems"
              v-bind:key="index"
              no-action
              three-line
              class="p-email__main-list"
            >
              <v-list-group
                v-model="group.active"
                v-bind:key="index"
                :class="[group.active ? 'p-list-email--select' : 'p-list-email']"
                @click="setData(group.id, group.projectId, group.active, index)"
              >
                <template v-slot:activator>
                  <v-list-item class="p-main-item" v-bind:key="index">
                    <v-list-item-avatar class="ml-4">
                      <p-avatar
                        :email="group.from.email"
                        :char="group.from.name[0]"
                        :size="40"
                      >
                      </p-avatar>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title
                        :class="[group.isRead ? 'text-from' : 'text-from p-bold-text']"
                        >
                        {{group.from.name}}
                      </v-list-item-title>
                      <v-list-item-subtitle
                        :class="[group.isRead ? 'p-body' : 'p-body p-bold-text']"
                        >
                        {{group.subject}}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action class="item-action mr-4">
                      <v-list-item-action-text
                        :class="[group.isRead ? '' : 'p-bold-text']"
                        v-text="getTime(group.createdAt)"
                      ></v-list-item-action-text>
                      <v-btn
                        v-if="group.emails != null && group.emails.length > 0"
                        icon
                      >
                        <v-icon>mdi-chevron-down</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </template>
                <v-list-item
                  v-for="item in group.emails"
                  v-bind:key="item.id"
                >
                  <v-list-item-avatar>
                    <p-avatar
                      :email="item.from.email"
                      :char="item.from.name? item.from.name[0]: item.from.email[0]"
                      :size="40"
                    >
                    </p-avatar>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      :class="{'p-bold-text': !(item.isRead || item.outgoing)}"
                      class="p-text-from"
                    >
                      {{ item.from.name? item.from.name: item.from.email }}
                    </v-list-item-title>
                    <v-list-item-subtitle
                      :class="{'p-bold-text': !(item.isRead || item.outgoing)}"
                      class="p-body"
                    >
                      {{item.subject}}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-list-item-action-text
                      :class="{'p-bold-text': !(item.isRead || item.outgoing)}"
                      v-text="getTime(item.createdAt)"
                    ></v-list-item-action-text>
                  </v-list-item-action>
                </v-list-item>
              </v-list-group>
              <v-divider></v-divider>
            </v-list>
          </v-list>
        </v-col>
        <v-col
          v-if="threadLoaded  && threads.length > 0"
          cols="12"
          sm="6"
          md="7"
          xl="8"
          class="mt-6 pl-0 p-email-thread"
        >
          <label
            v-if="emailItem != null && threadItems[emailIndexOld].to != null"
            class="p-email-label p-bold-text"
          >
            {{getDestinationText(threadItems[emailIndexOld].to)}}
          </label>
          <div
            v-if="emailItem == null || threadItems[emailIndexOld].to == null"
            class="mt-8"
          />
          <div>
            <email-item :thread="emailThread" :emailItem="emailItem" />
          </div>
        </v-col>
        <v-col
          v-if="threadLoaded && !search && threads.length <= 0"
          cols="4"
          md="12"
          class="mt-16"
        >
          <p-no-data
            :text="$t('email.noMessages')"
            :btn-text="$t('email.newMessage')"
            :hide-btn="!hasAccess()"
            img="chat.png"
            @btn-click="openSendDialog()"
          >
          </p-no-data>
        </v-col>
      </v-row>
    </div>

    <send-email-dialog :dialog.sync="sendDialog"></send-email-dialog>
  </div>
</template>


<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import moment from 'moment'

import PAvatar from '@/components/PAvatar'
import PSearchInput from '@/components/PSearchInput'
import PNoData from '@/components/PNoData'
import SendEmailDialog from './EmailSendDialog'
import EmailItem from './EmailItem'

import snackbarMixin from '@/mixins/snackbar.mixin'
import pageMixin from '@/mixins/page.mixin'
import accessMixin from '@/mixins/access.mixin'


export default {
  components: {
    PAvatar,
    PSearchInput,
    PNoData,
    SendEmailDialog,
    EmailItem
  },


  mixins: [
    snackbarMixin,
    pageMixin,
    accessMixin
  ],


  data () {
    return {
      threadItems: null,
      search: '',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      emailItem: null,
      emailThread: null,
      sendDialog: false,
      threadLoaded: false,
      onlyThisProject: true,
      emailIndexOld: null,
      unreadEmails: null
    }
  },


  computed: {
    ...mapState('thread', ['threads', 'threadEmails', 'threadTotalCount']),
    ...mapGetters('thread', ['searchSuggestions']),
    ...mapGetters('user', ['currentUserId', 'currentUser']),
    ...mapGetters('project', ['currentProjectId'])
  },


  watch: {
    'pagination.page': (newPage) => {
      this.reloadPage(newPage)
    },

    currentProjectId () {
      this.threadItems = null
      this.loadMembersByProject(this.currentProjectId)
      Promise.all([this.reloadPage()]).then(() => {
        this.setPagination()
      })
    }
  },


  methods: {
    ...mapActions('thread', ['loadThreads', 'loadThreadEmails']),
    ...mapActions('member', ['loadMembersByProject']),
    ...mapActions('notification', ['loadNotificationByProject']),
    ...mapActions('changes', ['removeFromChangedItems', 'removeFromChanges']),

    async getNotification () {
      const params = {
        projectId: this.currentProjectId,
        onlyThisProject: this.onlyThisProject
      }
      const response = await this.loadNotificationByProject(params)
      this.unreadEmails = response.data.unreadEmails
    },

    openSendDialog () {
      this.sendDialog = true
    },

    async setData (threadId, projectId, isActive, index) {
      if (!isActive) {
        this.clearOldSelected()
        this.threadItems[index].active = !isActive
        this.setRead(index)
        this.emailIndexOld = index
        this.startPageLoading()
        await this.loadThreadEmails({ projectId: projectId, threadId: threadId, userEmail: this.currentUser.email })
        this.emailItem = this.threadEmails
        this.emailThread = threadId
        this.stopPageLoading()
      } else {
        this.emailItem = null
        this.emailThread = null
      }
    },

    setRead (index) {
      if (!this.threadItems[index].isRead && this.threadItems[index].from.email === this.currentUser.email) {
        this.threadItems[index].isRead = true
        if (this.threadItems[index].emails != null) {
          this.threadItems[index].emails.forEach(e => (e.isRead = true))
        }
      }
    },

    clearOldSelected () {
      if (this.emailIndexOld !== null) {
        this.threadItems.forEach(e => (e.active = false))
        this.emailIndexOld = null
      }
    },

    async searchEmails (value) {
      await this.reloadPage(1, value)
      this.setPagination()
    },

    setPagination () {
      this.pageCount = Math.ceil(this.threadTotalCount / this.itemsPerPage)
      this.getNotification()
    },

    async reloadProjectThread () {
      this.page = 1
      await this.reloadPage()
      this.setPagination()
    },

    async reloadPage (page, search) {
      this.threadItems = null
      this.threadLoaded = false
      await this.nextPage(page, search)
    },

    async nextPage (page, search) {
      this.startPageLoading()
      this.emailItem = null
      this.emailIndexOld = null
      this.page = page || this.page
      await this.loadThreads({
        onlyThisProject: this.onlyThisProject,
        skip: (this.page - 1) * this.itemsPerPage,
        take: this.itemsPerPage,
        search: search || this.search
      })
      this.threadLoaded = true
      this.threadItems = this.threads
      this.getNotification()
      this.stopPageLoading()
    },

    getTime (emailDate) {
      if (emailDate === undefined) {
        return null
      }
      return moment(emailDate).format('MMM D')
    },

    getDestinationText (destinations) {
      let destination = ''
      for (let i = 0; i < destinations.length; i++) {
        if (destination.length > 0) {
          destination += ', '
        }
        destination += destinations[i].name
      }
      return destination
    }
  },


  async created () {
    try {
      this.loadMembersByProject(this.currentProjectId)
      await this.reloadPage()
      this.setPagination()
    } catch (error) {
      this.showSnackbarError()
      console.log(error)
      this.$log.error(error)
    }
  }
}
</script>
